import { Resource } from 'modules/core/base-resource';
import httpResource from 'modules/core/http-resource';

import { PlayerPosition } from 'modules/teams/domain/enums/player-position';
import { UserDto } from 'modules/roles-manager/domain/interfaces/user';

class PlayersResource extends Resource {
  constructor() {
    super('users', httpResource);
  }

  public async uploadPhoto(photo: File, playerId: number, tournamentId: number): Promise<UserDto> {
    const formData = new FormData();

    formData.append('image', photo);
    formData.append('tournamentId', `${tournamentId}`);

    return await this.child(`${playerId}/photo`).post(formData);
  }

  public async changeRole(
    teamId: number,
    userId: number,
    role: string,
    number: number | null,
    position: PlayerPosition | null,
  ) {
    return await this.absolute(`/teams/${teamId}/user-positions/${userId}`).put<any>({
      role: role.toLowerCase(),
      number,
      position,
    });
  }
}

const playersResource = new PlayersResource();
export default playersResource;
